import dayjs from "dayjs";

export const thirtyDays = 30 * 24 * 60 * 60 * 1000;

export const DAYSPRESETS = [
  { key: "last_7_days", type: "days" as const, value: 7 },
  { key: "last_14_days", type: "days" as const, value: 14 },
  { key: "last_30_days", type: "days" as const, value: 30 },
  { key: "last_2_months", type: "months" as const, value: 2 },
];
export function getActivePreset(dates: Date[]): string {
  if (!dates[0] || !dates[1]) return "";
  const start = dayjs(dates[0]);
  const end = dayjs(dates[1]);
  const today = dayjs();

  for (const preset of DAYSPRESETS) {
    const expectedStart =
      preset.type === "days"
        ? today.subtract(preset.value, "day")
        : today.subtract(preset.value, "month");

    if (
      Math.abs(end.diff(today, "hour")) <= 24 &&
      Math.abs(start.diff(expectedStart, "hour")) <= 24
    ) {
      return preset.key;
    }
  }
  return "";
}
